import * as React from 'react';

import '../Main.scss';

import {
    Button
} from 'reactstrap';

import UndoIcon from '@mui/icons-material/Undo';

import {
    Tooltip
} from '@mui/material';

import { UndoStack, UndoOperation } from '../../Utils/UndoStack';
import { PortalTextCommon } from '../../Models/Api/strongbox.financialportal';


type Props<OpDataType> = {
    undoStack: UndoStack<OpDataType>;
    showWhenEmpty?: boolean;
    style?: React.CSSProperties;
    disabled?: boolean;
    undo: (op: UndoOperation<OpDataType>) => void;
    tooltipPrompt?: string;
    commonText?: PortalTextCommon;
}

export const UndoButton: <OpDataType>(p: React.PropsWithChildren<Props<OpDataType>>) => React.ReactElement = props => {
    const {
        disabled,
        showWhenEmpty,
        style,
        tooltipPrompt,
        undoStack,
        undo,
        commonText,
    } = props;

    if (undoStack.isEmpty() && !showWhenEmpty) {
        return (<React.Fragment></React.Fragment>);
    }

    return (
        <Tooltip title={disabled !== false ? (tooltipPrompt || (commonText?.undoLastAction || '')) : ''}>
            <span>
                <Button
                    style={style}
                    onClick={(e) => {
                        const op = undoStack.pop();
                        undo(op);
                    }}
                    disabled={undoStack.isEmpty() || !!disabled}
                    color="primary"
                >
                    <UndoIcon />
                </Button>
            </span>
        </Tooltip>
    );
}
